import { defineComponent as i, h as n, ref as m, computed as l } from "vue";
import a, { popoverBaseProps as c } from "./highrise332.mjs";
import h from "./highrise1053.mjs";
import r from "./highrise984.mjs";
import d from "./highrise1027.mjs";
const f = Object.assign(Object.assign({}, c), r.props), P = i({
  name: "Tooltip",
  props: f,
  slots: Object,
  __popover__: !0,
  setup(e) {
    const {
      mergedClsPrefixRef: o
    } = h(e), s = r("Tooltip", "-tooltip", void 0, d, e, o), t = m(null);
    return Object.assign(Object.assign({}, {
      syncPosition() {
        t.value.syncPosition();
      },
      setShow(p) {
        t.value.setShow(p);
      }
    }), {
      popoverRef: t,
      mergedTheme: s,
      popoverThemeOverrides: l(() => s.value.self)
    });
  },
  render() {
    const {
      mergedTheme: e,
      internalExtraClass: o
    } = this;
    return n(a, Object.assign(Object.assign({}, this.$props), {
      theme: e.peers.Popover,
      themeOverrides: e.peerOverrides.Popover,
      builtinThemeOverrides: this.popoverThemeOverrides,
      internalExtraClass: o.concat("tooltip"),
      ref: "popoverRef"
    }), this.$slots);
  }
});
export {
  P as default,
  f as tooltipProps
};
